import theme from '../../../styles/theme'
import styled from '@emotion/styled'
import { InfoXXSmall500Style } from '../../../styles/Text.styles'

// Interfaces for styled component props
interface IconContainerProps {
  isInteractive?: boolean
}

interface StyledIconProps {
  src?: string
}

interface MarketItemIconProps {
  src?: string
}

export const IconContainer = styled.div<IconContainerProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  //hover
  ${(props) =>
    props.isInteractive &&
    `
    &:hover {
      outline: 3px solid ${theme.colors.backgroundDark};
    }
  `}
`

export const StyledIcon = styled.div<StyledIconProps>`
  width: 25px;
  height: 16px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 5px;
  border: 1px solid ${theme.colors.backgroundDark};
`

export const CountBadge = styled.div`
  position: absolute;
  bottom: -5px;
  right: -5px;
  background-color: ${theme.colors.surface};
  color: ${theme.colors.veryVeryVeryFadedText};
  border-radius: 10px;
  font-weight: 600;
  font-size: 10px;
  font-weight: bold;
  padding: 1px 3px;
  min-width: 16px;
  text-align: center;
  border: 1px solid ${theme.colors.veryVeryVeryFadedText};
  user-select: none;
`

export const OrangeBadge = styled.div`
  position: absolute;
  top: -5px;
  left: -5px;
  width: 8px;
  height: 8px;
  background-color: #ff7230;
  border-radius: 50%;
  border: 2px solid white;
  user-select: none;
`

export const Tooltip = styled.div`
  background-color: white;
  border: 1px solid ${theme.colors.backgroundDark};
  border-radius: 4px;
  padding: 8px;
  box-shadow: ${theme.shadows.medium};
  z-index: 2000;
  width: max-content;
  max-width: 200px;
  margin-top: 5px;
  transform: translateY(5px);
`

export const MarketsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 0.2rem;
`

export const MarketItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const ExternalItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0px;
`

export const MarketItemIcon = styled.div<MarketItemIconProps>`
  width: 19px;
  height: 14px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 5px;
  border: 1px solid ${theme.colors.backgroundDark};
`

export const MarketName = styled.span`
  ${InfoXXSmall500Style};
`

export const MarketItemOrangeBadge = styled.div`
  width: 8px;
  height: 8px;
  background-color: #ff7230;
  border-radius: 50%;
  border: 2px solid white;
  margin: 3px 2px 3px 2px;
`
